/**
 * Application Component
 ****************************************
 *
 * @version 1.0.1
 * @author Anjana Joy
 * @description Application for paper flow
 * @createdDate [27/03/2020]
 * ***************************************
 * @lastModifiedDate [27/03/2020]
 * @lastModifiedBy Anjana Joy
 * @lastModifiedReason
 */

import React, { Component } from 'react';
// import { PropTypes } from 'prop-types';
import { Row, Col, Container } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import { WCard, CommonButtons, WStepper } from '../../../common';
import AccGlobalConstants from '../AccountManagementConstants';
import consts from './consts';
import '../AgreementPaperFlow/agreementPaperFlow.css';

class ApplicationComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            next: false,
            back: false,
        };
    }

    // componentDidMount() {

    // }

    handlePdf = () => {
        window.open('https://www.antennahouse.com/XSLsample/pdf/sample-link_1.pdf');
    };

    handleBack = () => {
        this.setState({ back: true });
    };

    handleNext = () => {
        this.setState({ next: true });
    };

    render() {
        const { next, back } = this.state;
        const {
            paperFlowHeading,
            applicationHeading,
            applicationPara1,
            applicationPara2,
            applicationCard1Title,
            applicationCard2Title,
            downloadPdfText,
            cardtitlestyle,
        } = consts;

        return (
            <div>
                <Container className="paperFlowPage applicationPage">
                    <Row noGutters>
                        <Col>
                            <h1 className="pageHeading">{paperFlowHeading}</h1>
                            <WStepper pages={AccGlobalConstants.paperFlowPages} currentPage={3} />
                        </Col>
                    </Row>
                    <Row noGutters className="headerRow">
                        <Col>
                            <h2 className="pageSubHeading">{applicationHeading}</h2>
                        </Col>
                    </Row>
                    <Row noGutters className="contentRow">
                        <Col sm={12} className="contentWrapper">
                            <p className="strongPara">{applicationPara1}</p>
                            <p>{applicationPara2}</p>
                        </Col>
                    </Row>
                    <Row noGutters className="cardColWrapper">
                        <WCard
                            className=""
                            cardtitletext={applicationCard1Title}
                            cardtitlestyle={cardtitlestyle}
                            buttontext={downloadPdfText}
                            cardtext=""
                            pdflink="https://www.antennahouse.com/XSLsample/pdf/sample-link_1.pdf"
                            downloadtext="true"
                        />
                        <WCard
                            className=""
                            cardtitletext={applicationCard2Title}
                            cardtitlestyle={cardtitlestyle}
                            buttontext={downloadPdfText}
                            cardtext=""
                            pdflink="https://www.antennahouse.com/XSLsample/pdf/sample-link_1.pdf"
                            downloadtext="true"
                        />
                    </Row>
                </Container>
                <CommonButtons backClick={this.handleBack} nextClick={this.handleNext} />
                {next && <Redirect to="/uploadOrMail" />}
                {back && <Redirect to="/privacy" />}
            </div>
        );
    }
}

export default ApplicationComponent;
